import Email from '../src/Email';
export default Email;
